<div class="form-row" [ngClass]="{expanded: isOpen, dirty: isDirty, invalid: isInvalid }">
  <div class="header" (click)="toggle()">
    <ng-content select="[header-title]"></ng-content>
    <div class="button-group">
      @if (allowDuplicate) {
        <button class="btn standard-positive" (click)="doDuplicate($event)">
          <span class="icon">
            <svg-helper svgName="duplicate"></svg-helper>
          </span>
          <span class="label">Duplicate &amp; Add</span>
        </button>
      }
      @if (allowSave) {
        <button class="btn priority-positive" (click)="handleSave($event)">
          <span class="icon">
            <svg-helper svgName="save"></svg-helper>
          </span>
          <span class="label">Save</span>
        </button>
      }
      @if (allowPublish) {
        <button class="btn priority-positive" (click)="handlePublish($event)">
          <span class="icon">
            <svg-helper svgName="save"></svg-helper>
          </span>
          <span class="label">Publish</span>
        </button>
      }
      @if (publishing) {
        <publish-progress [publish]="publish"></publish-progress>
      }
      @if (allowDelete) {
        <button class="btn standard-negative" (click)="delete.emit()">
          <span class="icon">
            <svg-helper svgName="trash_can"></svg-helper>
          </span>
          <span class="label">Delete</span>
        </button>
      }
      @if (allowEditRequest) {
        <button class="btn standard-positive" (click)="requestEdit.emit()">
          <span class="icon">
            <svg-helper svgName="pencil_box"></svg-helper>
          </span>
          <span class="label">Change</span>
        </button>
      }

      <ng-content select="[header-buttons]"></ng-content>

      <div class="arrow">
        <div class="icon">
          <svg-helper svgName="carrot_arrow_right"></svg-helper>
        </div>
      </div>
    </div>
  </div>
  <div class="body">
    <ng-content select="[body]"></ng-content>
  </div>
</div>